const list = {
  // =================================================================================================================
  components () {
    return [
      {'component': 'search-start-end', "label": '작성일', "value":'date', "query":{'ss':'startDate', 'ee':'endDate'}, "options":{}},
      {'component': 'search-column-keyword',
        "label": '검색조건',
        "value":'column',
        "query":{'ck_t':'head', 'ck_k':'keyword'},
        "options": { hiddenList: ['작성일']}},
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  작성일
    if (search.date) {
      conditions.push({key: 'created_at', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'created_at', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map(e => { return {[e.name] : e.key} });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    //style: {width: '25%'}
    return [
      {
        "name": "사업장명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "소속명",
        "key": "body.stdInfo.department"
      },
      {
        "name": "부서명",
        "key": "body.stdInfo.com_name"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      },
      {
        "name": "작성일",
        "key": "created_at"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).stdInfo.field_name // 부서
      case 1:
        return func.getContent(value).stdInfo.department // 소속명
      case 2:
        return func.getContent(value).stdInfo.section // 부서명
      case 3:
        return func.getContent(value).stdInfo.writer_name // 작성자
      case 4:
        return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/
    }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
